import { Box, Button, Grid, Group, Text } from "@mantine/core";
import { FC, useState } from "react";
import { TYPE_TITLE_MAP } from "../consts";

export type ColorType = "last-check-in" | "status" | "until-follow-up" | "specialty-type";

interface Props {
  onApplyColor: (c?: ColorType) => void;
  onClose: () => void;
  initColor?: ColorType;
}

export const Colors: FC<Props> = ({ initColor, onApplyColor, onClose }) => {
  const [colorControl, setColorControl] = useState<ColorType | undefined>(initColor);

  return (
    <Box pos="relative" h="100%">
      <Text fz="sm" my="sm">
        Display <b>all</b> pins on map as different colors by:
      </Text>
      <Box ml={10}>
        <Group align="center" gap="sm" my="xs">
          <input
            type="radio"
            value="last-check-in"
            checked={"last-check-in" === colorControl}
            style={{
              transform: "scale(1.6)",
              marginTop: "-2px",
            }}
            onChange={(e) => setColorControl(e.target.value as ColorType)} />
          <Text fz="h4" fw="bold">
            {TYPE_TITLE_MAP.get("last-check-in")}
          </Text>
        </Group>
        <Group align="center" gap="sm" my="xs">
          <input
            type="radio"
            value="status"
            checked={"status" === colorControl}
            style={{
              transform: "scale(1.6)",
              marginTop: "-2px"
            }}
            onChange={(e) => setColorControl(e.target.value as ColorType)} />
          <Text fz="h4" fw="bold">
            {TYPE_TITLE_MAP.get("status")}
          </Text>
        </Group>
        <Group align="center" gap="sm" my="xs">
          <input
            type="radio"
            value="specialty-type"
            checked={"specialty-type" === colorControl}
            style={{
              transform: "scale(1.6)",
              marginTop: "-2px"
            }}
            onChange={(e) => setColorControl(e.target.value as ColorType)} />
          <Text fz="h4" fw="bold">
            {TYPE_TITLE_MAP.get("specialty-type")}
          </Text>
        </Group>
      </Box>
      <Grid
        pos="absolute"
        w="100%"
        bottom={20}>
        <Grid.Col span={6} style={{ boxSizing: "border-box" }}>
          <Button
            bg="#FF9D00"
            fullWidth
            style={{ boxSizing: "border-box" }}
            onClick={() => {
              setColorControl(undefined);
              onApplyColor(undefined)
            }}>
            Clear Colors
          </Button>
        </Grid.Col>
        <Grid.Col span={6} style={{ boxSizing: "border-box" }} >
          <Button
            bg="#4F7D9C"
            fullWidth
            style={{ boxSizing: "border-box" }}
            onClick={() => {
              onApplyColor(colorControl);
            }}>
            Apply
          </Button>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default Colors